import React from 'react';
import { NikeWebCommon } from '../../../types/generated/nike-web-common';

interface FooterPaymentMethodLogoProps {
    method: NikeWebCommon.FooterLogoDTO;
    imgHeight: HTMLImageElement['height'];
    className?: string;
    darkTheme?: boolean;
}

function FooterPaymentMethodLogo({ method, imgHeight, className, darkTheme }: FooterPaymentMethodLogoProps) {
    return (
        <a href={method.url} rel="noreferrer">
            <img
                src={darkTheme ? method.srcDm : method.src}
                alt={method.alt}
                height={imgHeight}
                className={className}
                loading="lazy"
            />
        </a>
    );
}

export default FooterPaymentMethodLogo;
